import axios from "axios";
import { cnxAPI, notifica, show_ldr, getUser } from "../requests/utils";
import api from "../service/api";
var d = null;

function getSolicitudes(_callback) {
  var usr = getUser();
  show_ldr(true);
  api.get(`candidatos/${usr.idCandidato}/solicitudes-postulacion`)
    .then(function (response) {
      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message || "Error desconocido", "Error en la consulta!");
        d = [];
      } else {
        d = response.data;
      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
      d = [];
    })
    .then(() => _callback(d));
}

function GetVideoRespuestasCandidato(data, _callback) {
  var usr = getUser(),
    json = { idCandidato: usr.idCandidato, idSolicitud: data.idSolicitud, idUsuario: 1 };
    api.get(`candidatos/${data.idSolicitud}/video-respuesta-candidato/${usr.idCandidato}?idUsuarioAct=1`)
    .then(function (response) {

      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Error en la consulta!");
      } else {
        d = response.data;

      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(d));
}
function DesVideoRespTecnicas(data, _callback) {

  var json = { idSolicitud: data.idSolicitud, idEstatus: false, idPregunta: data.idPregunta, idPreguntasTecnicas: data.idPreguntasTecnicas, idUsuario: 1 };

  show_ldr(true);
  axios({
    method: "post",
    url: cnxAPI + "Candidato/DeshabilitarRespTecnicas",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest"
    },
    data: json
  })
    .then(function (response) {

      show_ldr(false);
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Error en la consulta!");
      } else {
        d = response.data;

      }
    })
    .catch(function (error) {
      notifica("danger", error, "Error");
    })
    .then(() => _callback(d));
}


var pasos_post = [
  { title: "Postulación exitosa" },
  { title: "En Revisión" },
  { title: "Finalizado" }
];

var datos_post = [
  {
    tituloVacante: "Desarrollador Web Asp .Net Bilingüe",
    empresa: "Softek",
    idSolicitud: 59,
    lugar: "Ciudad de México",
    progreso: [
      {
        nombre: "Grabar Preguntas Tecnicas",
        fecha: "8 de Octubre",
        icono: "icon_video"
      },
    ]
  },
  {
    tituloVacante: "Desarrollador .Net y Front-End",
    empresa: "Sams Club",
    idSolicitud: 60,
    lugar: "Ciudad de México",
    progreso: [
      {
        nombre: "Grabar Preguntas Tecnicas",
        fecha: "8 de Octubre",
        icono: "icon_video"
      },
      {
        nombre: "En Revision",
        fecha: "8 de Octubre",
        icono: "icon_video"
      }
    ]
  },
  {
    tituloVacante: "Desarrollador iOS",
    empresa: "Praxis",
    idSolicitud: 61,
    lugar: "Ciudad de México",
    progreso: [
      {
        nombre: "Grabar Preguntas Tecnicas",
        fecha: "8 de Octubre",
        icono: "icon_video"
      }
    ]
  },
  {
    tituloVacante: "Desarrollador Aplicaciones Web y móviles",
    empresa: "HITSS",
    idSolicitud: 61,
    lugar: "Jalisco",
    progreso: [
      {
        nombre: "Grabar Preguntas Tecnicas",
        fecha: "8 de Octubre",
        icono: "icon_video"
      }
    ]
  }
];

export { datos_post, pasos_post, getSolicitudes, GetVideoRespuestasCandidato, DesVideoRespTecnicas };
